var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProgress24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.622 18.288a1.44 1.44 0 001-.39l6.37-5.96a.48.48 0 01.67 0l2.13 2.14a3.46 3.46 0 004.78 0l3.55-3.54a.241.241 0 01.34 0l1.7 1.69a.928.928 0 00.68.28.997.997 0 00.37-.07 1 1 0 00.59-.89v-5.8a1 1 0 00-1-1h-5.75a1 1 0 00-.68 1.65l1.7 1.69a.23.23 0 01.07.17.21.21 0 01-.07.17l-3.57 3.58a.5.5 0 01-.68 0l-2.14-2.14a3.35 3.35 0 00-4.69-.04l-6.36 6a1.44 1.44 0 00-.06 2 1.41 1.41 0 001.05.46z"
  })));
}
export default SvgIconProgress24;